import { Expose, Type } from 'class-transformer';
import {
  CommonModel,
  CommonParamInput,
} from 'common/repositories/common.model';

// Enum

export enum PaymentMethodEnum {
  Balance = 'balance',
  Bank = 'bank_transfer',
  ChequeGiro = 'cheque_giro',
  Cash = 'cash',
}

// Model

export class PaymentChannelLiteModel extends CommonModel {
  name: string;
  description: string;

  @Expose({ name: 'is_active' })
  @Type(() => Boolean)
  isActive: boolean;
}

export class PaymentChannelModel extends PaymentChannelLiteModel {}

// Input

export type getPaymentChannelsInput = {
  params: CommonParamInput;
};

export type getPaymentChannelInput = {
  id: string;
};

export type PaymentChannelMutationInput = {
  name: string;
  description: string;
};

export type PaymentChannelUpdateInput = {
  paymentChannelId: string;
  body: PaymentChannelMutationInput;
};

export type PaymentChannelDeleteInput = {
  paymentChannelId: string;
};
